import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "tailwindcss/tailwind.css";
import "./App.css";

import store from "./store/Store";
import AppContainer from "./AppContainer";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <div>
          <AppContainer />
        </div>
      </Router>
    </Provider>
  );
};

export default App;
